import type { AnalyticsData, Context } from '../../model/index.tsx';
import type { State } from '../types.tsx';

export const getContext = (state: State): Context => state.context;

export const getComponentId = (state: State): string => getContext(state).id;

export const getBaseUrl = (state: State): string => getContext(state).baseUrl;

export const getAnalyticsData = (state: State): AnalyticsData => getContext(state).analyticsData;
